let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1YQ60")).then(() => parcelRequire('bY3rp'));